import React from 'react';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

const LocationItem = ({ location }) => {
  return (
    <>
      <div className="map-img-div">
        <BusinessOutlinedIcon color="primary" />
      </div>
      <div className="location-name">{location?.location}</div>
      <style jsx>
        {`
          .location-name {
            margin-left: 10px;
          }
        `}
      </style>
    </>
  );
};

export default LocationItem;
